import moment from "moment-timezone";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTV } from "../../hooks/useTV";
import useGlobalStore from "../../store/global.store";

const VacationCountdown = ({
  countDownDate,
  currentDate,
  timezone,
  last_name,
}) => {
  const { isTv } = useTV();
  const setShowSettings = useGlobalStore((state) => state.setShowSettings);
  const setSettingsInitialView = useGlobalStore(
    (state) => state.setSettingsInitialView
  );

  const getDaysLeft = () => {
    const countdownEnd = moment(countDownDate).tz(timezone);
    const current = moment(currentDate).tz(timezone);

    let dl = countdownEnd.diff(current, "days");
    if (dl < 0) {
      dl = 0;
    }
    return dl;
  };

  const [showLastName, setShowLastName] = useState(false);
  const [showDaysLeft, setShowDaysLeft] = useState(false);
  const [firstPlay, setFirstPlay] = useState(true);
  const [focusedButton, setFocusedButton] = useState(null);
  const loopVidRef = useRef(null);

    const nameRef = useRef(null);
  const baseNameSize = isTv ? 400 : 300;
  const [nameFontSize, setNameFontSize] = useState(baseNameSize);

  useLayoutEffect(() => {
    const fitName = () => {
      const el = nameRef.current;
      if (!el) return;
      el.style.fontSize = baseNameSize + "px";
      const w = el.offsetWidth;
      const maxW = window.innerWidth * 0.9;
      const size = w > maxW ? Math.floor(baseNameSize * (maxW / w)) : baseNameSize;
      el.style.fontSize = size + "px";
      setNameFontSize(size);
    };
    fitName();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitName);
  }, [last_name, baseNameSize]);

  const handleSetVacationDate = () => {
    setSettingsInitialView("VacationDate");
    setShowSettings(true);
  };

  useEffect(() => {
    const video = document.getElementById("vc-video");
    video.volume = localStorage.getItem("volume") || 0.3;
    video.play();

    const interval = setInterval(() => {
      const currentTime = video.currentTime;

      if (currentTime >= 2 && currentTime < 6) {
        setShowLastName(true);
        setShowDaysLeft(false);
      } else if (currentTime >= 7 && currentTime < 20) {
        setShowLastName(false);
        setShowDaysLeft(true);
      } else {
        setShowLastName(false);
        setShowDaysLeft(false);
      }

      if (currentTime > 19) {
        // console.log('first play end');
        setFirstPlay(false);
        clearInterval(interval);
      }
    }, 100); // Check every 100ms

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (loopVidRef.current) {
      const video = document.getElementById("loop-video");
      video.volume = localStorage.getItem("volume") || 0.3;
      video.play();
    }
  }, [loopVidRef]);

  // TV-specific styles for the family name
  const familyNameStyle = {
    fontSize: nameFontSize + "px",
    whiteSpace: "nowrap",
    width: "max-content",
    color: "white",
    position: "absolute",
    top: isTv ? "20%" : "22%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 100,
    fontFamily: "MOUSE",
    lineHeight: 0,
    opacity: showLastName ? 1 : 0,
    transition: "opacity 0.5s",
    textShadow: "4px 4px 45px rgba(9,90,202,1)",
  };

  // TV-specific styles for the days remaining counter
  const daysLeftStyle = {
    fontSize: isTv ? "400px" : "300px",
    color: "white",
    position: "absolute",
    top: "10%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 100,
    fontFamily: "MOUSE",
    lineHeight: 1,
    opacity: showDaysLeft ? 1 : 0,
    transition: "opacity 0.5s",
    textShadow: "4px 4px 45px rgba(9,90,202,1)",
  };

  // Button style for "Set Vacation Date"
  const setVacationButtonStyle = {
    position: "absolute",
    top: isTv ? "50px" : "30px",
    right: isTv ? "50px" : "20px",
    zIndex: 150,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    border:
      isTv && focusedButton === "set-vacation"
        ? "6px solid #3ADF3C"
        : isTv
        ? "6px solid white"
        : "2px solid white",
    color: "white",
    fontFamily: "Lato",
    fontSize: isTv ? "40px" : "18px",
    padding: isTv ? "15px 30px" : "12px 24px",
    borderRadius: "10px",
    fontWeight: "600",
    cursor: "pointer",
    outline: "none",
    transition: "all 0.3s ease",
    backdropFilter: "blur(5px)",
    minWidth: isTv ? "300px" : "auto",
    textAlign: "center",
  };

  return (
    <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
      {firstPlay ? (
        <>
            <span ref={nameRef} style={familyNameStyle}>{last_name}</span>

          {countDownDate && timezone && (
            <>
              {getDaysLeft() >= 0 ? (
                <span style={daysLeftStyle}>{getDaysLeft()}</span>
              ) : (
                <span></span>
              )}
            </>
          )}

          <button
            tabIndex={0}
            onFocus={() => setFocusedButton("set-vacation")}
            onBlur={() => setFocusedButton(null)}
            onClick={handleSetVacationDate}
            style={setVacationButtonStyle}
          >
            Set Vacation Date
          </button>

          <video
            id={"vc-video"}
            src="https://cdn.mywaitserver.live/cd-1.mp4"
            style={{
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
              pointerEvents: "none",
            }}
          ></video>
        </>
      ) : (
        <>
          {countDownDate && timezone && (
            <>
              {getDaysLeft() >= 0 ? (
                <span style={daysLeftStyle}>{getDaysLeft()}</span>
              ) : (
                <span></span>
              )}
            </>
          )}

          <button
            tabIndex={0}
            onFocus={() => setFocusedButton("set-vacation")}
            onBlur={() => setFocusedButton(null)}
            onClick={handleSetVacationDate}
            style={setVacationButtonStyle}
          >
            Set Vacation Date
          </button>

          <video
            loop={true}
            muted={true}
            autoPlay={true}
            ref={loopVidRef}
            id={"loop-video"}
            src="https://cdn.mywaitserver.live/cd-2.mp4"
            style={{
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
              pointerEvents: "none",
            }}
          ></video>
        </>
      )}
    </div>
  );
};

export default VacationCountdown;
